"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceStyling = void 0;
var tslib_1 = require("tslib");
var api_model_bear_1 = require("@gooddata/api-model-bear");
var errorHandling_1 = require("../../../utils/errorHandling");
var BearWorkspaceStyling = /** @class */ (function () {
    function BearWorkspaceStyling(authCall, workspace) {
        var _this = this;
        this.authCall = authCall;
        this.workspace = workspace;
        this.getColorPalette = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var palette;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) { return sdk.project.getColorPaletteWithGuids(_this.workspace); })];
                    case 1:
                        palette = _a.sent();
                        return [2 /*return*/, palette || []];
                }
            });
        }); };
        this.getTheme = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var config, identifier;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) { return sdk.project.getProjectFeatureFlags(_this.workspace); })];
                    case 1:
                        config = _a.sent();
                        identifier = config.selectedUiTheme;
                        return [2 /*return*/, identifier
                                ? this.authCall(function (sdk) {
                                    return sdk.md
                                        .getObjectByIdentifier(_this.workspace, identifier)
                                        .then(function (object) {
                                        var unwrappedObject = api_model_bear_1.GdcMetadataObject.unwrapMetadataObject(object);
                                        return (api_model_bear_1.GdcMetadata.isTheme(unwrappedObject) && unwrappedObject.content) || {};
                                    })
                                        .catch(function (err) {
                                        if (errorHandling_1.isApiResponseError(err)) {
                                            return {};
                                        }
                                        throw err;
                                    });
                                })
                                : {}];
                }
            });
        }); };
    }
    return BearWorkspaceStyling;
}());
exports.BearWorkspaceStyling = BearWorkspaceStyling;
//# sourceMappingURL=styling.js.map